import React from 'react';
import Layout from '../../components/Layout/Layout';
import CardGroup from '../../components/CardGroup/CardGroup';
import styles from './CardGroupPage.module.css';

const CardGroupPage = () => {
  const handleCardSelect = (cardId) => {
    console.log(`Card selected: ${cardId}`);
  };

  return (
    <Layout width="1440px">
      <div className={styles.cardgroupGrid}>
        <CardGroup
          size="Desktop 1200"
          cardCount={5}
          groupPick12={1}
          groupPick7={1}
          cardId1="53d6cd36-d17b-44a8-9bb4-45bf53ffab97"
          cardId2="d2a0c76d-0d7b-4d58-8ecc-47f80a6a1094"
          cardId3="8741ff4a-c1bc-4561-960e-0bc602cdb81a"
          cardId4="bfc92ab9-b206-4fa2-b379-ab6962a1fcc7"
          cardId5="ba27923a-c587-4410-ada9-1a1cdc9c20d9"
          onCardSelect={handleCardSelect}
        />
      </div>
    </Layout>
  );
};

export default CardGroupPage;